import { queryOptions } from "@tanstack/react-query";
import { createServerFn } from "@tanstack/react-start";
import { getPublicFounderProfileBySlug } from "@/lib/founders";

export const fetchFounderProfile = createServerFn({ method: "GET" })
	.inputValidator((data: { founderSlug: string }) => data)
	.handler(async ({ data }) => {
		const founder = await getPublicFounderProfileBySlug(data.founderSlug);
		return { founder };
	});

export type FounderProfileData = Awaited<
	ReturnType<typeof fetchFounderProfile>
>;

export const founderProfileQueryOptions = (founderSlug: string) =>
	queryOptions({
		queryKey: ["founder-profile", founderSlug] as const,
		queryFn: () => fetchFounderProfile({ data: { founderSlug } }),
		staleTime: 60_000,
		retry: false,
	});
